<div class="mbm-modal">
  <div class="mbm-modal-handle" aria-hidden="true"></div>
  <header class="mbm-modal-header">
    <h2 class="mbm-modal-title mbm-truncate">{{ title() ?? (titleKey() | translate) }}</h2>
    @if (showCloseButton()) {
      <button type="button" class="mbm-modal-close" [attr.aria-label]="'general.close' | translate" (click)="modalClose.emit()">
        <img src="assets/icons/close-dark.svg" alt="" aria-hidden="true" class="mbm-modal-close-icon" />
      </button>
    }
  </header>
  <div class="mbm-modal-body mbm-scrollbar">
    @if (errorMessages().length || successMessages().length) {
      <div class="mbm-modal-messages">
        @for (msg of successMessages(); track msg.id) {
          <mbm-alert type="success" [messageKey]="msg.messageKey" />
        }
        @for (msg of errorMessages(); track msg.id) {
          <mbm-alert type="error" [messageKey]="msg.messageKey" />
        }
      </div>
    }
    <div class="mbm-modal-scrollable-content">
      <ng-content select="[slot='modal-content']"></ng-content>
    </div>
    <footer class="mbm-modal-footer">
      <ng-content select="[slot='modal-footer']"></ng-content>
    </footer>
  </div>
</div>
